import { isProductionApp } from "./appEnv";

const selectBillingResource = <T>(productionValue: T, nonProductionValue: T): T => (isProductionApp ? productionValue : nonProductionValue);

const requireEnvVar = (value: string | undefined, name: string): string => {
    if (!value) {
        throw new Error(`${name} is required for the selected app environment.`);
    }

    return value;
};

export const stripePublishableKey = isProductionApp
    ? requireEnvVar(process.env.REACT_APP_STRIPE_LIVE_PUBLISHABLE_KEY, "REACT_APP_STRIPE_LIVE_PUBLISHABLE_KEY")
    : requireEnvVar(process.env.REACT_APP_STRIPE_TEST_PUBLISHABLE_KEY, "REACT_APP_STRIPE_TEST_PUBLISHABLE_KEY");

export const billingEnvironmentLabel = selectBillingResource("production", "dev");

export const stripeCallableNames = {
    cancelSubscription: selectBillingResource("stripe-cancelSubscription", "stripeDev-cancelSubscription_DEV"),
    changeSubscriptionPrice: selectBillingResource("stripe-changeSubscriptionPrice", "stripeDev-changeSubscriptionPrice_DEV"),
    convertTrialToPaid: selectBillingResource("stripe-convertTrialToPaid", "stripeDev-convertTrialToPaid_DEV"),
    createEmbeddedCheckoutSession: selectBillingResource("stripe-createEmbeddedCheckoutSession", "stripeDev-createEmbeddedCheckoutSession_DEV"),
    createRegistrationElementsSession: selectBillingResource("stripe-createRegistrationElementsSession", "stripeDev-createRegistrationElementsSession_DEV"),
    createSubscription: selectBillingResource("stripe-createSubscription", "stripeDev-createSubscription_DEV"),
    detachPaymentMethod: selectBillingResource("stripe-detachPaymentMethod", "stripeDev-detachPaymentMethod_DEV"),
    getCouponDetails: selectBillingResource("stripe-getCouponDetails", "stripeDev-getCouponDetails_DEV"),
    getProductPrices: selectBillingResource("stripe-getProductPrices", "stripeDev-getProductPrices_DEV"),
    listPaymentMethods: selectBillingResource("stripe-listPaymentMethods", "stripeDev-listPaymentMethods_DEV"),
    reactivateSubscription: selectBillingResource("stripe-reactivateSubscription", "stripeDev-reactivateSubscription_DEV"),
    retrieveCustomerCard: selectBillingResource("stripe-retrieveCustomerCard", "stripeDev-retrieveCustomerCard_DEV"),
    updateCustomerEmail: selectBillingResource("stripe-updateCustomerEmail", "stripeDev-updateCustomerEmail_DEV"),
    updatePaymentMethod: selectBillingResource("stripe-updatePaymentMethod", "stripeDev-updatePaymentMethod_DEV"),
    verifyEmbeddedCheckoutSession: selectBillingResource("stripe-verifyEmbeddedCheckoutSession", "stripeDev-verifyEmbeddedCheckoutSession_DEV"),
    verifyRegistrationElementsPayment: selectBillingResource("stripe-verifyRegistrationElementsPayment", "stripeDev-verifyRegistrationElementsPayment_DEV"),
} as const;

export const coachCallableNames = {
    submitEnterpriseLead: "coaches-submitEnterpriseLead",
} as const;

export const stripeProductIds = {
    subscription: selectBillingResource("prod_UKQrYXH8j7XyMZ", "prod_UN3LLvxqC8zp4O"), // <-- Example product IDs, replace with actual values
} as const;
